///
/// EarthBrowser - PostHog Analytics
///
/// Created by Matt Giger on 6/13/2025
/// Copyright (c) 2025 Geodata Labs
///
/// Tier 2 (consented, identified) analytics. Called explicitly from
/// main.tsx: this file was a Next.js auto-load convention that nothing
/// imported after the Vite migration, so PostHog never initialized in
/// production until Oct 2026. Kept lean on purpose — no autocapture (DOM
/// noise on a WebGL canvas app), no session recording by default, no
/// web vitals (Cloudflare Web Analytics covers those), identified-only
/// person profiles. Every capture goes through utils/analytics.ts, which
/// decides per event whether PostHog sees it (cPostHogEvents).
///

import posthog from 'posthog-js'
import { hasPerformanceConsent, hasConsentChoice } from '@/utils/privacy-consent'

export function initPostHog(): boolean {
	const posthogKey = import.meta.env.VITE_POSTHOG_KEY
	const posthogHost = import.meta.env.VITE_POSTHOG_HOST
	if (!posthogKey || !posthogHost) {
		return false
	}

	posthog.init(posthogKey, {
		api_host: posthogHost,
		capture_pageview: 'history_change',
		autocapture: false,
		capture_performance: false,
		disable_session_recording: true,
		person_profiles: 'identified_only',
		// Start with capturing disabled if no consent given (GDPR compliant)
		opt_out_capturing_by_default: !hasConsentChoice() || !hasPerformanceConsent(),
		// Respect Do Not Track browser setting
		respect_dnt: true,
		// Don't persist user data until consent is given
		persistence: hasPerformanceConsent() ? 'localStorage+cookie' : 'memory',
	})
	return true
}
